import { codeKey, sPkg, uuIdKey } from '@/constants'
import { initSentry } from 'web-utils/sentry'
import { isInNativeApp, deviceInfo } from 'web-utils/device'
import { getAppType, isRealTgEnv } from './index'

export default function setupSentry(app) {
  // 客户端关闭广告回调，先预定义，防止sentry告警
  window.closeAdvertise = () => {
    console.log('app close advertise')
  }
  const env = import.meta.env.MODE
  const isPro = env === 'pro'
  if (!isPro) {
    return
  }
  const customTags = {
    appType: getAppType(),
    pkg: sPkg,
    inTg: isRealTgEnv(),
    inApp: false,
    code: localStorage.getItem(codeKey) || ' ',
    webUuid: localStorage.getItem(uuIdKey) || ' '
  }
  if (isInNativeApp()) {
    const { appVersion, appType, code } = deviceInfo() || {}
    customTags.nativeAppVersion = appVersion
    customTags.appType = appType
    customTags.code = code
    customTags.inApp = true
  }
  const release = process.env.VITE_SENTRY_RELEASE
  initSentry({
    isVue3: true,
    vueInstance: app,
    env,
    dsn: 'https://6db7dc1df5aee18eb72a36909af9e540@sentry.taer.xyz/7',
    customTags,
    // eslint-disable-next-line no-undef
    release
  })
  // 会在请求工具类里面放到x-info里面，有助于协助排查问题
  window._sentryRelease_ = release
  window.onActivityResume = () => {}
}
